import { GetMainSectionFn } from '../custom-topic-routes'
import { billboardLeaderboardMrec } from 'thewest/routes/ad-units'

export const getRTS2019RouteInfo: GetMainSectionFn = sectionBuilder => {
    return [
        ...sectionBuilder.getCuratedSection(),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Keynotes',
                    headingUrl: '/business/rts2019-keynotes',
                    section: 'business',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['business/rts2019-keynotes'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Panels',
                    headingUrl: '/business/rts2019-panels',
                    section: 'business',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['business/rts2019-panels'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('one'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Exhibition',
                    headingUrl: '/business/rts2019-exhibition',
                    section: 'business',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['business/rts2019-exhibition'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('two'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'lg',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                loadMoreEnabled: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },
                sectionHeader: {
                    heading: 'Latest',
                    section: 'business',
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['business/rts2019'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        },
    ]
}
